import { createAction, props } from '@ngrx/store';

export const setAppSettings = createAction('[App Module] Set App Settings', props<{ appSettings: { [key: string]: string } }>());
